import { motion } from "motion/react";

const TENSOR_VIDEO = "https://customer-assets.emergentagent.com/job_heritage-global-1/artifacts/jynxjg9s_tensor%203%20d%20escena%20final%20fondo%20web%20bhg.mp4";

const EJES = [
  {
    eje: "Eje X",
    title: "Lo que ya somos",
    text: "Hotelería, gastronomía, agro, transporte, guías. La materia prima del llano.",
  },
  {
    eje: "Eje Y",
    title: "Lo que el mundo busca",
    text: "Bienestar, agroturismo, naturaleza, economía naranja. Los rubros no tradicionales que generan divisas.",
  },
  {
    eje: "Eje Z",
    title: "El propósito",
    text: "Los Objetivos de Desarrollo Sostenible de la ONU. La garantía de que crecemos sin destruir lo nuestro.",
  },
];

export const Metodo = () => {
  return (
    <section id="metodo" className="relative overflow-hidden" data-testid="section-metodo">
      <video
        src={TENSOR_VIDEO}
        autoPlay
        loop
        muted
        playsInline
        preload="metadata"
        className="absolute inset-0 w-full h-full object-cover"
        data-testid="metodo-tensor-video"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-[#0A0908] via-transparent to-[#0A0908] pointer-events-none" />

      <div className="relative z-10 max-w-6xl mx-auto px-6 py-24 md:py-32">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          className="liquid-glass-strong rounded-3xl p-8 md:p-12 text-center max-w-3xl mx-auto"
        >
          <p className="text-xs uppercase tracking-[0.35em] text-[#C6A15B] mb-4">El método detrás de todo</p>
          <h2 className="font-serif-display text-3xl sm:text-4xl lg:text-5xl text-white font-medium mb-5" data-testid="metodo-title">
            No vendemos paisajes. Diseñamos estructura.
          </h2>
          <p className="text-base md:text-lg text-white/80">
            Detrás de cada proyecto hay una arquitectura que lo hace trazable, transversal y financiable.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1, delay: 0.2, ease: "easeOut" }}
          className="text-center my-14 md:my-20"
          data-testid="metodo-xyz-symbol"
        >
          <p className="text-sm md:text-base uppercase tracking-[0.4em] text-[#C6A15B] mb-6">Tensor de Orden 3</p>
          <span className="font-serif-display text-6xl sm:text-7xl lg:text-8xl font-medium tracking-wide text-white drop-shadow-[0_2px_12px_rgba(0,0,0,0.8)]">
            X <span className="text-white/40">·</span> <span className="text-[#C6A15B]">Y</span> <span className="text-white/40">·</span> Z
          </span>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.9, ease: "easeOut" }}
          className="liquid-glass-strong rounded-3xl p-8 md:p-12 max-w-3xl mx-auto"
          data-testid="metodo-programa-box"
        >
          <p className="text-sm md:text-base text-white/85 leading-relaxed mb-5">
            Programa de Investigación de Barinas Heritage Global: el Tensor X·Y·Z como núcleo firme,
            siete direcciones como hilos, y la trazabilidad origen→ejecución→impacto como forma de fe.
            Validado en campo. Registrable. Replicable en cualquier territorio.
          </p>
          <p className="text-sm md:text-base text-white/70 leading-relaxed">
            Cruza lo que Barinas ya tiene con lo que el mundo busca, y lo ancla a los Objetivos de
            Desarrollo Sostenible. Así, cada iniciativa deja de ser una buena idea suelta y se
            convierte en un proyecto con trazabilidad del origen al impacto.
          </p>
        </motion.div>

        {/* momento protagonista del video del Tensor */}
        <div className="h-[55vh] md:h-[70vh]" data-testid="metodo-video-spotlight" />

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {EJES.map((item, i) => (
            <motion.div
              key={item.eje}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, delay: i * 0.2, ease: "easeOut" }}
              className="liquid-glass-strong rounded-3xl p-8"
              data-testid={`metodo-card-${i + 1}`}
            >
              <p className="text-xs uppercase tracking-[0.3em] text-[#C6A15B] mb-3">{item.eje}</p>
              <h3 className="font-serif-display text-2xl text-white font-medium mb-4">{item.title}</h3>
              <p className="text-sm text-white/70 leading-relaxed">{item.text}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
